export const ellipsizeAddress = (address: string): string => {
  if (!address) return undefined
  const start = address.substring(0, 5)
  const i = address.length - 4
  const end = address.substring(i, i + 4)

  return `${start}...${end}`
}
